<template>
  <div>
    <div v-if="isReimbursement" class="container">
      <div class="nav">
        <div class="nav_hader">
          <ul class="nav_left">
            <li class="bottom hove" @click="onMine()" :class="{ active: active === 'mine' }">
              我的报销事项
            </li>
            <li class="bottom hove" @click="onAll()" :class="{ active: active === 'all' }">
              全部报销事项
            </li>
            <li class="bottom hove" @click="onSub()" :class="{ active: active === 'sub' }">
              我下属的报销事项
            </li>
          </ul>
          <ul class="nav_right">
            <li>
              <exportExcel></exportExcel>
            </li>
            <li>
              <el-button style="margin-right:0px" type="primary" class="btn-big" icon="el-icon-plus" @click="onAdd">
                新增报销
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <div style="width: 100%">
        <div class="nav_body">
          <div class="grid">
            <div class="cell">
              <div class="grid-content bg-purple">报销事项：</div>
              <div class="selection">
                <el-select v-model="source_id" @change="changeSource" placeholder="请选择">
                  <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">选择下属：</div>
              <div class="selection" @click="handleSub">
                <el-input placeholder="请选择下属" v-model="subName" suffix-icon="el-icon-arrow-down" @click.stop>
                </el-input>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">自定义字段：</div>
              <div>
                <el-input v-model="selfC" placeholder="请输入自定义字段搜索" clearable @change="chaxun"> </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body">
        <div>
          <div class="input">
            <div class="mind"></div>
            <div class="abu">
              <el-input v-model="input" type="number" @blur="getValueData" min="0"
                onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
                placeholder="请输入金额" clearable @change="chaxun">
                <el-button slot="append" @click="chaxun">查询</el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div class="table">
          <el-table id="educe-table" ref="multipleTable" :data="tableData" stripe v-loading="tableLoading"
            @row-click="handleRead">
            <div v-for="(item, index) in fields" :key="index">
              <el-table-column v-if="item.prop == 'photo'" :prop="item.field" :label="item.title">
                <template slot-scope="scope">
                  <template v-if="scope.row.photo">
                    <div v-for="i in scope.row.photo" :key="i">
                      <img class="pic" :src="i" />
                      <div v-show="false">{{ i }}</div>
                        <!-- 表格导出用到 -->
                    </div>
                  </template>
                  <template v-else>暂无</template>
                </template>
              </el-table-column>
              <el-table-column sortable v-else-if="item.field == 'check_status_name'" :prop="item.field" :label="item.title">
                  <template slot-scope="scope">
                <!-- <span v-if="scope.row.check_status === 0 "
                style="color: #409EFF"
                  >待审核</span
                >
                <span
                  v-else-if="scope.row.check_status === 1"
                  style="color: #F56C6C"
                  >审核中</span
                >
                <span
                  v-else-if="scope.row.check_status === 2"
                  style="color: #67C23A"
                  >审核通过</span
                >
                <span
                  v-else-if="scope.row.check_status === 3"
                  style="color: #F56C6C"
                  >审核未通过</span
                > -->
                <el-tag v-if="scope.row.check_status === 0 "
                size="mini"
                  >待审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.check_status === 1"
                  type="danger"
                  size="mini"
                  >审核中</el-tag
                >
                <el-tag
                  v-else-if="scope.row.check_status === 2"
                  type="success"
                  size="mini"
                  >审核通过</el-tag
                >
                <el-tag
                  v-else-if="scope.row.check_status === 3"
                  type="danger"
                  size="mini"
                  >审核未通过</el-tag
                >
              </template>
                </el-table-column>
              <el-table-column v-else show-overflow-tooltip :prop="item.field" :label="item.title"> </el-table-column>
            </div>
            <el-table-column class-name="operation" align="center" fixed="right"  width="145">
              <template slot="header">
                <span>操作</span>
                <i class="more iconfont icongengduo" @click="onMore"></i>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleRead(scope.row)" type="text">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="getData" />
      </div>
      <el-tooltip placement="top" content="返回顶部">
        <back-to-top :visibility-height="300" :back-position="0" transition-name="fade" />
      </el-tooltip>
      <add ref="add"></add>
      <contact ref="ContactAdd" type="leads" :id="leads_id"></contact>
      <mail-list ref="drawer" :module="module" @handleSelect="handleSelect"></mail-list>
      <set-table ref="setting" types="applyExpense" :selfState="selfState"></set-table>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import add from './add'
import contact from '@/components/Contact/add'
import mailList from '@/components/drawer/mailList'
import exportExcel from '@/components/exportExcel'
import Pagination from '@/components/Pagination'
import setTable from '@/components/setTable'
import qs from 'qs'
import { getApplyItemList, checkPhone } from '@/api/common'
import { getFieldControl } from '@/api/user'

export default {
  name: 'clues',
  inject: ['reload'],
  components: {
    add,
    Pagination,
    setTable,
    contact,
    mailList,
    exportExcel
  },
  data() {
    return {
      //当前页面state
      selfState: 'applyExpense',
      showAdd: false,
      forms: [],
      btn: '',
      module: '',
      active: 'mine',
      activeR: 'all',
      actives: 0,
      source: [],
      source_id: '',
      is_record: 0,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20
      },
      boxShow: false,
      onSubmit: false,
      recordTime: '',
      value: '',
      tableData: [],
      input: '',
      createTime: '',
      if_leader: '',
      start_createtime: '',
      end_createtime: '',
      start_followtime: '',
      end_followtime: '',
      multipleSelection: [],
      fileList: [],
      baseURL: this.axios.defaults.baseURL,
      page: '1',
      loading: false,
      form: {
        enterprisePhoto: ''
      },
      value4: [],
      onSubmitss: false,
      fields: [],
      leads_id: 0,
      lockSave: false,
      lockAdd: false,
      lockDel: false,
      lockOther: false,
      lockPool: false,
      subName: '',
      subUserid: '',
      numMoney: 0,
      selfC: "",
      tableLoading: true
    }
  },
  computed: {
    isReimbursement() {
      return this.$route.name === 'reimbursement'
    }
  },
  created() {
    this.getFields()
  },
  async mounted() {
    this.if_leader=window.sessionStorage.getItem('bx_if_leader');

    if(this.if_leader == 3){
      this.onAll()
    }else if(this.if_leader == 1){
      this.onSub()
    }else{
      this.onMine()
    }
    await this.getSource()

  },
  methods: {
    //操作表头
    onMore() {
      this.$refs.setting.open()
    },
    //获取自定义字段 getSelfAPI
    // async getFields() {
    //   const res = await getSelfAPI({
    //     account_id: this.$store.state.user.token.account_id,
    //     state: this.selfState,
    //     user_id: this.$store.state.user.token.userid
    //   })
    //   if (res.code == 1) {
    //     this.fields = res.data.merge_field
    //   } else {
    //     this.fields = []
    //   }
    // },
    async getFields() {
      let fields = await getFieldControl({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        types: 'applyExpense'
      })
      this.tableLoading = false
      this.fields = fields.data
    },
    handleClear() {
      this.subName = ''
      this.subUserid = ''
      this.getData()
    },
    handleSub() {
      this.listQuery.page = 1
      this.module = 'getUnderUser'
      this.$refs.drawer.open()
    },
    async onCheckTel(obj) {
      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel
        })
        obj.errorMsg = res.msg
        obj.code = res.code
      } catch (error) {
        console.log(error)
      }
    },
    addPhone(item) {
      item.push({
        tel: '',
        errorMsg: '',
        code: 0
      })
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: '',
          errorMsg: '',
          code: 0
        }
        arr.push()
        return
      }
      arr.splice(index, 1)
    },
    async getSource() {
      const source = await getApplyItemList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid
      })
      this.apply_item_id = 0
      source.data.unshift({
        id: 0,
        name: '全部'
      })
      this.source = source.data.map(i => {
        return {
          value: i.id,
          label: i.name
        }
      })
    },
    async getData(d) {
      // if((this.input||this.apply_item_id)||(this.is_record||this.selfC)){
      //   this.listQuery.page=1
      // }
      // 判断是否是选择下属的id
      const userid = this.subUserid ? this.subUserid : this.$store.state.user.token.userid
      const tableData = await this.axios.post(
        '/crm/ApplyExpense/applyExpenseList',
        qs.stringify({
          account_id: this.$store.state.user.token.account_id,
          userid,
          if_leader: this.if_leader,
          money: this.input,
          page: this.listQuery.page,
          apply_item_id: this.apply_item_id,
          is_record: this.is_record,
          number_page: d?.limit ?? 20,
          self_content: this.selfC
        })
      )
      this.total = tableData.count
      this.tableData = tableData.data
      for (var a = 0; a < tableData.data.length; a++) {
        this.tableData[a].photo = this.tableData[a].photo.split(',')
      }

    },
    formSubmit() {
      this.btn = 'submit'
      this.onSave()
    },
    onAdd() {
      this.$refs.add.open()
    },
    closeAdd() {
      this.showAdd = false
    },
    addContact() {
      this.btn = 'add'
      this.onSave()
    },
    handleSelect(person) {
      // 选择下属
      if (this.module === 'getUnderUser') {
        this.if_leader = '0'
        this.subName = person.name
        this.subUserid = person.userid
        this.getData()
      }
    },
    handleRead(row) {
      this.$router.push({
        name: 'reimbursementDetail',
        params: {
          id: row.id
        },
        query: {
          owner: row.userid,
          if_leader:this.if_leader

        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_record === 1) {
        return 'success-row'
      }
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      }
      return ''
    },
    changeSource() {
      this.listQuery.page = 1
      this.apply_item_id=this.source_id
      //this.selfC=this.source_id
      this.getData()
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 名称查询
    chaxun() {
      this.listQuery.page = 1
      this.getData()
    },
    pull() {
      this.toggle = !this.toggle
    },
    onAll() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'all'
      this.if_leader = '3'
      this.input = ''
      this.listQuery.limit = 20
      this.listQuery.page = 1
      this.getData()
    },
    onMine() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'mine'
      this.if_leader = '0'
      this.input = ''
      this.listQuery.limit = 20
      this.listQuery.page = 1
      this.getData()
    },
    onSub() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'sub'
      this.if_leader = '1'
      this.input = ''
      this.listQuery.limit = 20
      this.listQuery.page = 1
      this.getData()
    },
    numoo() {
      this.loading = true
      this.daoru()
    },
    daoru() {
      this.axios
        .post(
          '/crm/Leads/importDataLeads',
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            file_path: this.form.enterprisePhoto,
            page: this.page
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          if (res.code == 1) {
            this.page = this.page * 1 + 1
            this.daoru()
          } else if (res.code == 3) {
            this.loading = false
            this.onSubmitss = true
            this.value4 = res.data
            this.onAll()
            return
          } else if (res.code == 2) {
            this.loading = false
            this.onAll()
            this.$message({
              message: res.msg,
              type: 'success'
            })
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    chenggong(response, file) {
      this.$message({
        message: response.msg,
        type: 'success'
      })
      this.form.enterprisePhoto = file.response.data
    },
    handleExceed() {
      this.$message.warning(
        `当前限制选择 1 个文件，如需更换请先删除`
      )
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    /*只允许金额为数字*/
    getValueData() {
      if (this.numMoney) {
        let a = this.numMoney.substring(0, 1);
        let b = this.numMoney.substring(1, 2);
        if (a == '0' && b != '.') {
          this.numMoney = this.numMoney.slice(1);
        }
      }
    },

  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/index-common.scss';

.pic {
  width: 50px;
  height: 50px;
}
</style>
